<template>
  <div class="header-wrap">
    <div class="header">
      <div><img src="@/assets/images/back-btn.svg" alt=""></div>
      <div>Playing Now</div>
      <div><img src="@/assets/images/menu-btn.svg" alt=""></div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.header-wrap {
  .header {
    height: 6.6vh;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 17px;
    font-weight: 600;
    padding: 0 15px;
  }
}
</style>
